<template>
  <div>
    <PageAllow controller="Purchases" action="index" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <!-- 创建时间 -->
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 批量打印 -->
              <v-btn
                v-if="
                  $route.path.startsWith('/purchases-examine') &&
                  $permission.permissionAllow('Purchases', 'batchExamine')
                "
                small
                color="warning"
                class="ms-1 float-end"
                @click="batchExamineDialog = true"
              >
                <v-icon x-small class="pe-1">fa-align-justify</v-icon>
                {{ $t("PurchasesList.Fields.examine") }}
              </v-btn>
              <!-- 批量打印 -->
              <v-btn
                v-if="
                  (!$route.path.startsWith('/purchases-') &&
                    $permission.permissionAllow(
                      'Purchases',
                      'purchasesPrint'
                    )) ||
                  ($route.path.startsWith('/purchases-') &&
                    $permission.permissionAllow(
                      'Purchases',
                      'purchaseExaminesPrint'
                    ))
                "
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="doPrint('purchasesPrint')"
              >
                <v-icon x-small class="pe-1">fa-print</v-icon>
                {{ $t("PurchasesList.Fields.print") }}
              </v-btn>

              <!-- 批量云打印 -->
              <v-btn
                v-if="
                  ((!$route.path.startsWith('/purchases-') &&
                    $permission.permissionAllow(
                      'Purchases',
                      'purchasesPrint'
                    )) ||
                    ($route.path.startsWith('/purchases-') &&
                      $permission.permissionAllow(
                        'Purchases',
                        'purchaseExaminesPrint'
                      ))) &&
                  $permission.permissionAllow('CloudPrints', 'index') &&
                  settings &&
                  settings.cloud_print_enable
                "
                small
                color="print"
                dark
                class="ms-1"
                @click.stop="doCloudPrint('adminPurchase')"
              >
                <v-icon x-small class="pe-1">fa-print</v-icon>
                {{ $t("Print.batch_cloud_print") }}
              </v-btn>
              <!-- 批量确认 -->
              <v-btn
                v-if="
                  !$route.path.startsWith('/purchases-') &&
                  $permission.permissionAllow('Purchases', 'batchConfirm')
                "
                small
                color="orange"
                dark
                class="ms-1"
                @click="batchConfirmDialog = true"
              >
                <v-icon x-small class="pe-1">fa-check</v-icon>
                {{ $t("PurchasesList.Fields.confirm") }}
              </v-btn>
              <v-menu
                v-model="importBtnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
                v-if="
                  !$route.path.startsWith('/purchases-') &&
                  $permission.permissionAllow('Purchases', 'import')
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    color="print"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ms-1"
                  >
                    {{ $t("PurchasesList.import.title") }}
                    <v-icon x-small class="ps-1">{{
                      importBtnMenu ? "fa-caret-up" : "fa-caret-down"
                    }}</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <!-- 一言为定导入 -->
                  <v-list-item @click="ImportExcelDialog = true">
                    <v-list-item-title>
                      {{ $t("PurchasesList.import.default_import") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <!-- 新建采购单 -->
              <v-menu
                v-model="addBtnMenu"
                open-on-hover
                close-on-click
                close-on-content-click
                offset-y
                v-if="
                  !$route.path.startsWith('/purchases-examine') &&
                  $permission.permissionAllow('Purchases', 'add')
                "
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    class="ms-1"
                  >
                    <v-icon x-small class="pe-1">fa-plus</v-icon>
                    {{ $t("PurchasesList.Fields.add") }}
                    <v-icon x-small class="ps-1">{{
                      addBtnMenu ? "fa-caret-up" : "fa-caret-down"
                    }}</v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <!-- 根据产品采购 -->
                  <v-list-item href="/#/purchases/new-from-products">
                    <v-list-item-title>
                      {{ $t("PurchasesList.add.product") }}
                    </v-list-item-title>
                  </v-list-item>
                  <!-- 向供货商采购 -->
                  <v-list-item href="/#/purchases/new-from-suppliers">
                    <v-list-item-title>
                      {{ $t("PurchasesList.add.supplier") }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <!-- 批量导出 -->
              <v-btn
                v-if="
                  $route.path.startsWith('/purchases-examine') &&
                  $permission.permissionAllow('Purchases', 'examineBatchExport')
                "
                small
                color="print"
                dark
                class="ms-1"
                @click="batchExportExcel()"
              >
                <v-icon x-small class="pe-1">fa-file-export</v-icon>
                {{ $t("PurchasesList.Fields.export") }}
              </v-btn>
              <!-- 批量后议价 -->
              <v-btn
                v-if="
                  $permission.permissionAllow(
                    'Purchases',
                    'getNegotiatePriceDetails'
                  ) &&
                  !$route.path.startsWith('/purchases-') &&
                  settings &&
                  settings.purchase_after_set_price == 1
                "
                small
                color="primary"
                class="elevation-1 ms-1"
                :disabled="!showSelected.length"
                @click="batchNegotiate()"
              >
                {{ $t("PurchasesList.Fields.NegotiatePrices") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 采购单号 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="purchase_code"
                    v-model="options.purchase_code"
                    @text="purchaseCodeKeyword = $event"
                    :label="$t('PurchasesList.Fields.purchase_code')"
                  />
                </v-col>
                <!-- 第三方单号 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="ext_code"
                    v-model="options.ext_code"
                    @text="purchaseKeyword = $event"
                    :label="$t('PurchasesList.Fields.purchase')"
                  />
                </v-col>
                <!-- 供应商分组 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="district_keyword"
                    v-model="options.district_keyword"
                    @text="districtKeyword = $event"
                    :label="$t('PurchasesList.Fields.district_keyword')"
                  />
                </v-col>
                <!-- 供应商 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherSuppliers v-model="supplierSelected" />
                </v-col>
                <!-- 仓库中心 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStocks v-model="stocksSelected" :stock-types="[0]" />
                </v-col>
                <!-- 采购单来源 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherPurchaseOriginFlgs v-model="options.origin_flgs" />
                </v-col>
                <!-- 来源包括订单转采购时 订单号检索 -->
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="
                    options.origin_flgs.find((p) => p == 102) ? true : false
                  "
                >
                  <SearcherKeyword
                    ref="order_code"
                    v-model="options.order_code"
                    @text="orderCodeKeyword = $event"
                    :label="$t('PurchasesList.Fields.order_code')"
                  />
                </v-col>
                <!-- 商品 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherMaterials v-model="options.material_ids" returnId />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <!-- 状态 -->
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('PurchasesList.status.ObjectName')"
                    :items="$consts.purchaseStatus"
                    v-if="!$route.path.startsWith('/purchases-examine')"
                  />
                  <SearcherStatus
                    v-model="options.examine_status"
                    :label="$t('PurchasesList.status.ObjectName')"
                    :items="$consts.purchaseExamineStatus"
                    v-if="$route.path.startsWith('/purchases-examine')"
                  />
                </v-col>
                <!-- 供应商分区 -->
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  v-if="settings && settings.account_supplier"
                >
                  <div
                    class="caption grey--text input-chip-group-label"
                    :class="
                      $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                    "
                  >
                    {{ $t("Supplier.SupplyType.ObjectName") }}
                  </div>
                  <v-radio-group
                    row
                    class="me-1"
                    style="margin-top: -0.2rem"
                    v-model="options.SupplierType"
                  >
                    <v-radio
                      :label="$t('Supplier.SupplyType.all')"
                      :key="-1"
                      :value="-1"
                    />
                    <v-radio
                      :label="$t('Supplier.SupplyType.common')"
                      :key="1"
                      :value="1"
                    />
                    <v-radio
                      :label="$t('Supplier.SupplyType.platform')"
                      :key="2"
                      :value="2"
                    />
                  </v-radio-group>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <!-- 发货状态 -->
                  <SearcherStatus
                    v-model="options.delivery_flgs"
                    :label="$t('PurchasesList.deliveryFlgs.ObjectName')"
                    :items="$consts.purchaseDeliverFlgs"
                    :disable="disabledStatus"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <!-- 表格 -->
        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="purchases"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1 sticky-table"
            id="sticky-table"
            :class="stickTableCols ? 'sticky-first-col sticky-last-col' : ''"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              <span class="ml-3">
                {{ header.text }}
                <v-icon x-small>fa-sliders-h</v-icon>
              </span>
            </template>
            <template v-slot:item.purchase_code="{ item, index }">
              <span
                class="text-no-wrap caption font-weight-bold"
                :v-resize="!index ? $stickTableResizer() : null"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.purchase_code }}
              </span>
              <br />
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.created | formatTime }}
              </span>
            </template>
            <template v-slot:item.stock.name="{ item }">
              <span
                v-if="
                  item.stock && item.stock.name && item.stock.name.length > 8
                "
                :title="item.stock.name"
                style="cursor: pointer"
                class="text-no-wrap"
              >
                {{ item.stock.name.slice(0, 8) + "......" }}
              </span>
              <span v-else class="text-no-wrap">
                {{ item.stock ? item.stock.name : "" }}
              </span>
            </template>
            <template v-slot:item.supplier.supplier_name="{ item }">
              <span
                v-if="
                  item.supplier &&
                  item.supplier.supplier_name &&
                  item.supplier.supplier_name.length > 8
                "
                :title="item.supplier.supplier_name"
                style="cursor: pointer"
                class="text-no-wrap"
              >
                {{ item.supplier.supplier_name.slice(0, 8) + "......" }}
              </span>
              <span v-else class="text-no-wrap">
                {{ item.supplier ? item.supplier.supplier_name : "" }}
              </span>
            </template>
            <!-- 日期 ⬇ -->
            <template v-slot:item.hope_delivery_date="{ item }">
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.hope_delivery_date | formatDate }}
              </span>
            </template>
            <template v-slot:item.created="{ item }">
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.created | formatTime }}
              </span>
            </template>
            <template v-slot:item.complete_date="{ item }">
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.complete_date | formatTime }}
              </span>
            </template>
            <!-- 日期 ⬆ -->
            <!-- 操作 -->
            <!-- 状态文字 -->
            <template v-slot:item.status="{ item }">
              <v-chip
                small
                label
                :color="item.status | purchaseStatusColor"
                :text-color="item.status | purchaseStatusTextColor"
              >
                {{ item.status | purchaseStatusText }}
                <span
                  v-if="
                    item.third_return && item.third_return.push_platform == 1010
                  "
                >
                  ({{ item.third_return.status | purchaseThirdStatusText }})
                </span>
              </v-chip>
            </template>
            <template v-slot:item.origin_flg="{ item }">
              <v-chip
                small
                label
                :color="item.origin_flg | originFlgsColor"
                :text-color="item.origin_flg | originFlgsTextColor"
              >
                {{ item.origin_flg | originFlgsText }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <PurchasesActions
                :purchase="item"
                showView
                :showEdit="
                  !$route.path.startsWith('/purchases-') && item.actions.edit
                "
                :showFinish="
                  $route.path.startsWith('/purchases-examine') &&
                  item.actions.over &&
                  item.actions.examine &&
                  item.supplier &&
                  item.supplier.type != 2
                "
                :showLogistic="
                  $route.path.startsWith('/purchases-examine') &&
                  item.logistics_json != null
                "
                :showExamine="
                  $route.path.startsWith('/purchases-examine') &&
                  item.actions.examine &&
                  item.supplier &&
                  item.supplier.type != 2
                "
                :showConfirm="
                  !$route.path.startsWith('/purchases-') && item.actions.confirm
                "
                :showCancel="
                  !$route.path.startsWith('/purchases-') && item.actions.cancel
                "
                :showNotice="
                  !$route.path.startsWith('/purchases-') && item.actions.notice
                "
                :showNegotiate="!$route.path.startsWith('/purchases-')"
                :showCopy="
                  !$route.path.startsWith('/purchases-') && item.actions.copy
                "
                showPrint
                :showExport="!$route.path.startsWith('/purchases-')"
                :showExamineExport="
                  $route.path.startsWith('/purchases-examine')
                "
                :showPurchaseToSupplierOrder="
                  settings &&
                  settings.account_supplier &&
                  !$route.path.startsWith('/purchases-') &&
                  !item.purchase_order_code &&
                  item.supplier &&
                  item.supplier.type == 2 &&
                  item.status > 1
                "
                :showSupplierExamine="
                  settings &&
                  settings.account_supplier &&
                  $route.path.startsWith('/purchases-examine') &&
                  item.supplier &&
                  item.supplier.type == 2 &&
                  item.wait_in_flg == 1
                "
                @done="getPurchasesFromAPI()"
                class="ml-3"
              />
            </template>
            <template v-slot:header.data-table-select>
              <v-checkbox
                class="mt-2 mb-n2"
                color="primary"
                v-model="negotiatePriceAll"
                :indeterminate="
                  purchases.find((e) => {
                    if (e.negotiate_price_flg) {
                      return e.negotiate_flg != negotiatePriceAll;
                    } else {
                      return false;
                    }
                  })
                    ? true
                    : false
                "
                :true-value="1"
                :false-value="0"
              >
              </v-checkbox>
            </template>
            <template v-slot:item.data-table-select="{ item }">
              <v-checkbox
                class="mt-2 mb-n2"
                v-if="
                  $permission.permissionAllow(
                    'Purchases',
                    'getNegotiatePriceDetails'
                  ) && item.negotiate_price_flg == 1
                "
                color="primary"
                v-model="item.negotiate_flg"
                :true-value="1"
                :false-value="0"
              >
              </v-checkbox>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <BatchConfirmDialog
      v-model="batchConfirmDialog"
      @confirm="
        batchConfirm();
        batchConfirmDialog = false;
      "
    />
    <ImportExcelAlert
      v-model="ImportExcelDialog"
      :objName="$t('PurchasesList.ObjectName')"
      @import="
        excelFile = $event;
        importExcel();
      "
    />
    <ImportPurchasesResult
      v-model="ImportPurchasesResultDialog"
      :errorPurchases="errorPurchases"
    />
    <!-- 批量验收 -->
    <DialogAlert
      v-model="batchExamineDialog"
      :title="$t('$vuetify.warning')"
      :message="$t('PurchasesList.messages.batchExamineAlert')"
      persistent
      useConfirm
      @confirm="
        batchExamineDialog = false;
        batchExamineInfoDialog = true;
        batchExamine(JSON.parse(JSON.stringify(options)));
      "
    />
    <BatchOperationInfoAlert
      v-model="batchExamineInfoDialog"
      :title="$t('$vuetify.alert')"
      :message="batchExamineInfo"
      persistent
      :closable="errorCount > 0"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherStocks from "@/components/plugins/SearcherStocks";
import BatchConfirmDialog from "@/components/plugins/BatchConfirmDialog";
import DialogAlert from "@/components/plugins/DialogAlert";
import BatchOperationInfoAlert from "./plugins/BatchOperationInfoAlert";
import Purchases from "@/api/purchases";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherSuppliers from "@/components/plugins/SearcherSuppliers";
import SearcherMaterials from "@/components/plugins/SearcherMaterials";
import SearcherPurchaseOriginFlgs from "@/components/plugins/SearcherPurchaseOriginFlgs";
import PurchasesActions from "./plugins/Actions";
import CloudPrintTemplates from "@/api/cloud_print_templates";
import ImportExcelAlert from "./plugins/ImportExcelAlert";
import ImportPurchasesResult from "./plugins/ImportPurchasesResult.vue";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 7 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  complete_time_from: "",
  complete_time_to: "",
  status: [1, 2, 3, 4],
  examine_status: [2, 3, 4],
  delivery_flgs: [],
  material_id: null,
  stock_area_id: null,
  position_label_id: null,
  stock_position_id: null,
  purchase_code: "",
  ext_code: "",
  district_keyword: "",
  order_code: "",
  supplier_ids: null,
  origin_flgs: [],
  material_ids: [],
  SupplierType: -1,
};

export default {
  computed: {
    disabledStatus() {
      // 仅 等待验收 时 发货状态可选
      if (
        this.options.status &&
        this.options.status.length == 1 &&
        this.options.status[0] == 2
      ) {
        return false;
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.options.delivery_flgs = [];
        return true;
      }
    },
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.purchases"),
          disabled: false,
          href: "/purchases",
        },
        {
          text: this.$route.path.startsWith("/purchases-examine")
            ? i18n.t("Nav.purchasesExamine")
            : i18n.t("Nav.purchasesList"),
          disabled: true,
          href: this.$route.path.startsWith("/purchases-examine")
            ? "/purchases-examine"
            : "/purchases",
        },
      ];
    },
    headers() {
      var headers = [];
      if (
        this.$permission.permissionAllow(
          "Purchases",
          "getNegotiatePriceDetails"
        ) &&
        !this.$route.path.startsWith("/purchases-") &&
        this.settings &&
        this.settings.purchase_after_set_price == 1
      ) {
        headers.push({
          text: "",
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "data-table-select",
        });
      }
      headers.push(
        {
          text: i18n.t("PurchasesList.Fields.purchase_code"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "purchase_code",
        },
        {
          text: i18n.t("PurchasesList.Fields.stock_name"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "stock.name",
        },
        {
          text: i18n.t("PurchasesList.Fields.supplier_name"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "supplier.supplier_name",
        },
        {
          text: i18n.t("PurchasesList.Fields.origin_flg"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "origin_flg",
        },
        {
          text: i18n.t("PurchasesList.Fields.expect_date"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "hope_delivery_date",
        },
        {
          text: i18n.t("PurchasesList.Fields.complete_date"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "complete_date",
        },
        {
          text: i18n.t("PurchasesList.Fields.status"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "actions",
        }
      );
      return headers;
    },
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("StockPosition.Fields.create"),
      },
      {
        key: "complete",
        text: i18n.t("StockPosition.Fields.complete"),
      },
    ],
    ...mapState(["settings", "stickTableCols"]),
  },

  mounted() {
    if (this.$route.query.stock_id) {
      this.stocksSelected = [{ id: Number(this.$route.query.stock_id) }];
      this.onSearch();
    } else {
      this.$commonUtils
        .loadOptions("purchases", ["stocksSelected", "supplierSelected"])
        .then(
          function (data) {
            if (data.options) {
              this.options = data.options;
            } else this.resetSearch();
            data.selecteds.forEach((selected) => {
              switch (selected.key) {
                case "stocksSelected":
                  this.stocksSelected = selected.value;
                  break;
                case "supplierSelected":
                  this.supplierSelected = selected.value;
                  break;
              }
            });
          }.bind(this)
        );
    }
  },

  components: {
    Breadcrumbs,
    SearcherStocks,
    PageAllow,
    SearcherKeyword,
    SearcherSuppliers,
    SearcherMaterials,
    SearcherPurchaseOriginFlgs,
    SearcherStatus,
    SearcherDatetimeRangeWithRadio,
    PurchasesActions,
    BatchConfirmDialog,
    ImportExcelAlert,
    DialogAlert,
    BatchOperationInfoAlert,
    ImportPurchasesResult,
  },

  data: () => ({
    importBtnMenu: false,
    addBtnMenu: false,
    batchConfirmDialog: false,
    purchases: [],
    purchaseCodeKeyword: "",
    orderCodeKeyword: "",
    purchaseKeyword: "",
    districtKeyword: "",
    supplierSelected: [],
    stocksSelected: [],
    paging: {},
    options: JSON.parse(
      sessionStorage.getItem("purchases-options")
        ? sessionStorage.getItem("purchases-options")
        : JSON.stringify(defaultOptions)
    ),
    loading: false,
    batchConfirmedErrAmount: 0,
    batchConfirmedAmount: 0,
    invalidOrderId: [],
    printBtnMenu: false,
    ImportExcelDialog: false,
    ImportPurchasesResultDialog: false,
    errorPurchases: [],
    excelFile: null,
    showSelected: [],
    negotiatePriceAll: 0,
    batchExamineDialog: false,
    batchExamineInfoDialog: false,
    batchExamineInfo: i18n.t("PurchasesList.messages.batchExamineInfo", [0, 0]),
    batchExamineErrorDialog: false,
    batchExamineErrorData: [],
    successCount: 0,
    errorCount: 0,
    error_purchase_id: [],
    alreadyExaminedLength: 0,
  }),

  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        purchase_code: this.purchaseCodeKeyword,
        ext_code: this.purchaseKeyword,
        district_keyword: this.districtKeyword,
        order_code: this.orderCodeKeyword,
      });
    },
    resetSearch() {
      this.stocksSelected = [];
      this.supplierSelected = [];
      var options = JSON.parse(JSON.stringify(defaultOptions));
      this.options = options;
      [
        this.$refs.purchase_code,
        this.$refs.ext_code,
        this.$refs.order_code,
        this.$refs.district_keyword,
      ].forEach((k) => {
        if (k) k.clear();
      });
    },
    getPurchasesFromAPI() {
      this.loading = true;
      let options = Object.assign({}, this.options, {
        status: this.$route.path.startsWith("/purchases-examine")
          ? this.options.examine_status
          : this.options.status,
      });
      if (options.SupplierType == -1) {
        options.supplier_type = [1, 2];
      } else {
        options.supplier_type = [options.SupplierType];
      }
      Purchases.fetch(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.purchases = response.data.purchases;
            this.paging = response.data.paging;
            this.purchases = this.purchases.map((purchase) => {
              // 采购后议价
              // purchase.negotiate_flg = 0;
              return Object.assign({}, purchase, { negotiate_flg: 0 });
            });
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
          this.loading = false;
        }.bind(this)
      );
    },
    batchConfirm() {
      Purchases.batchConfirm(
        Object.assign({}, this.options, {
          no_confirm_order_id: this.invalidOrderId,
        })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.confirm_status) {
              // 失败的成功的 弹窗使用
              if (response.data.amount == 0) {
                this.invalidOrderId.push(response.data.order_id);
                this.batchConfirmedErrAmount += 1; // 失败的
              } else {
                this.batchConfirmedAmount += 1; // 成功的
              }

              this.batchConfirm(); //循环调用接口
            } else if (!response.data.confirm_status) {
              //循环结束，数据刷新
              this.$snackbar.info(
                i18n.t("PurchasesList.messages.batchConfirmMessages", [
                  this.batchConfirmedAmount,
                  this.batchConfirmedErrAmount,
                ])
              );
              this.batchConfirmedErrAmount = 0;
              this.batchConfirmedAmount = 0;
              this.invalidOrderId = [];
              this.getPurchasesFromAPI();
            }
          }
        }.bind(this)
      );
    },
    batchExamine(options) {
      if (this.error_purchase_id.length) {
        options.no_purchase_ids = this.error_purchase_id;
      }
      Purchases.batchExamine(options).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (response.data.examine_flg) {
              ++this.successCount;
            } else {
              this.error_purchase_id.push(response.data.purchase_id);
              ++this.errorCount;
            }
          } else {
            if (response.data.error.code != "ERR333") {
              this.error_purchase_id.push(response.data.purchase_id);
              ++this.errorCount;
              if (response.data.error.code == "ERR668") {
                this.batchExamineErrorData.push(response.data.data[0]);
                this.batchExamineErrorDialog = true;
              }
            } else {
              this.getPurchasesFromAPI();
              options = null;
              this.error_purchase_id = [];
              this.successCount = 0;
              this.errorCount = 0;
              this.alreadyExaminedLength = 0;
              this.batchExamineInfoDialog = false;
              this.$store.commit("refreshToDos", true);
            }
          }
          //实时计数
          this.batchExamineInfo = i18n.t(
            "PurchasesList.messages.batchExamineInfo",
            [this.successCount, this.errorCount]
          );
          ++this.alreadyExaminedLength; //计已确认的单子总数
          if (
            response.data.status.isOK() ||
            response.data.error.code != "ERR333"
          ) {
            //回调
            this.batchExamine(options);
          }
        }.bind(this)
      );
    },
    doPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          var options = Object.assign(
            {},
            JSON.parse(JSON.stringify(this.options)),
            {
              status: this.$route.path.startsWith("/purchases-examine")
                ? this.options.examine_status
                : this.options.status,
            }
          );
          options.page = 1;
          options.itemsPerPage = this.$consts.limitAll;
          switch (mode) {
            case "purchasesPrint":
              this.$router.push({
                path: "/print/purchases-print/",
                query: options,
              });
              break;
          }
        }.bind(this)
      );
    },
    doCloudPrint(mode) {
      this.$permission.checkAccountExpired().then(
        function () {
          let options = Object.assign(
            {},
            JSON.parse(JSON.stringify(this.options)),
            {
              status: this.$route.path.startsWith("/purchases-examine")
                ? this.options.examine_status
                : this.options.status,
            }
          );
          options.page = 1;
          options.itemsPerPage = this.$consts.limitAll;
          if (mode == "adminPurchase") {
            //获取单据详情
            Purchases.purchasesPrint(options).then(
              function (response) {
                if (response.data.status.isOK()) {
                  let purchases = [];
                  response.data.purchases.forEach((purchase) => {
                    purchase.purchase_details.map((d) => {
                      d.sum = Number(d.price) * Number(d.quantity);
                      if (d.negotiate_price_flg == 1) {
                        // 显示后议价
                        // 单价
                        d.price = this.$t(
                          "PurchasesDetail.purchaseFields.negotiatePrices"
                        );
                        // 采购金额
                        d.total = this.$t(
                          "PurchasesDetail.purchaseFields.negotiatePrices"
                        );
                      }
                      return d;
                    });
                    purchases.push(purchase);
                  });
                  CloudPrintTemplates.batchPrint({
                    print_template_code: mode,
                    objects: purchases,
                  });
                }
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
    importExcel() {
      this.$store.dispatch("fullscreenLoading");
      Purchases.Import(this.excelFile)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$snackbar.info(
                i18n.t("Import.success", [i18n.t("PurchasesList.ObjectName")])
              );
              this.ImportExcelDialog = false;
              this.getPurchasesFromAPI();
            } else if (response.data.status == "NG") {
              this.ImportExcelDialog = false;
              if (response.data.error_data) {
                this.errorPurchases = response.data.error_data;
                this.ImportPurchasesResultDialog = true;
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    batchExportExcel() {
      Purchases.examineBatchExports(
        Object.assign({}, this.options, {
          status: this.$route.path.startsWith("/purchases-examine")
            ? this.options.examine_status
            : this.options.status,
        })
      );
    },
    batchNegotiate() {
      if (this.showSelected.length) {
        var purchaseIds = this.showSelected.map((s) => {
          return s.id;
        });
        this.$router.push({
          path: "/purchases/batch-negotiate-price",
          query: {
            purchase_ids: encodeURI(purchaseIds),
          },
        });
      }
    },
  },

  watch: {
    $route() {
      this.getPurchasesFromAPI();
    },
    options: {
      deep: true,
      handler() {
        if (!this.options.origin_flgs.find((p) => p == 102)) {
          this.options.order_code = "";
          this.orderCodeKeyword = "";
        }
        this.getPurchasesFromAPI();
        sessionStorage.setItem(
          "purchases-options",
          JSON.stringify(this.options)
        );
      },
    },
    // 仓配中心搜索
    stocksSelected: {
      handler() {
        this.options.stock_ids = this.stocksSelected
          ? this.stocksSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "purchases-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
    // 供应商
    supplierSelected: {
      handler() {
        this.options.supplier_ids = this.supplierSelected
          ? this.supplierSelected.map((e) => {
              return e.id;
            })
          : "";
        sessionStorage.setItem(
          "purchases-supplierSelected",
          JSON.stringify(this.supplierSelected)
        );
      },
    },

    negotiatePriceAll: {
      handler() {
        this.purchases = this.purchases.map(
          function (purchase) {
            if (
              this.$permission.permissionAllow(
                "Purchases",
                "getNegotiatePriceDetails"
              ) &&
              purchase.negotiate_price_flg == 1
            ) {
              purchase.negotiate_flg = this.negotiatePriceAll ? 1 : 0;
            }
            return purchase;
          }.bind(this)
        );
      },
    },
    purchases: {
      deep: true,
      handler() {
        this.showSelected = [];
        this.purchases.forEach((purchase) => {
          if (purchase.negotiate_flg == 1) {
            this.showSelected.push(purchase);
          }
        });
        // console.log(this.showSelected);
      },
    },
  },
};
</script>